import _includes from 'lodash/includes';
import Cookie from 'js-cookie';

export default {
    state: {
        card: false,
        modal: 'lead-initiated',
        started: false,
        sid: null,
        showSpaLayout: false,

        lead: {},
        tenant: {},
        directConnect: {},

        closableModals: [
            'calendly-scheduled',
            'call-error',
            'call-scheduled',
            'lead-busy',
            'lead-canceled',
            'lead-choice',
            'lead-completed',
            'lead-failed',
            'lead-no-answer',
            'schedule-appointment',
            'tenant-answered',
            'tenant-busy',
            'tenant-canceled',
            'tenant-failed',
            'tenant-no-answer',
        ],

        events: [
            '.App\\Domain\\DirectConnect\\Events\\Leads\\Answered',
            '.App\\Domain\\DirectConnect\\Events\\Leads\\Busy',
            '.App\\Domain\\DirectConnect\\Events\\Leads\\Canceled',
            '.App\\Domain\\DirectConnect\\Events\\Leads\\Completed',
            '.App\\Domain\\DirectConnect\\Events\\Leads\\Failed',
            '.App\\Domain\\DirectConnect\\Events\\Leads\\Initiated',
            '.App\\Domain\\DirectConnect\\Events\\Leads\\NoAnswer',
            '.App\\Domain\\DirectConnect\\Events\\Leads\\Ringing',
            '.App\\Domain\\DirectConnect\\Events\\Tenants\\Answered',
            '.App\\Domain\\DirectConnect\\Events\\Tenants\\Busy',
            '.App\\Domain\\DirectConnect\\Events\\Tenants\\Canceled',
            '.App\\Domain\\DirectConnect\\Events\\Tenants\\Failed',
            '.App\\Domain\\DirectConnect\\Events\\Tenants\\Initiated',
            '.App\\Domain\\DirectConnect\\Events\\Tenants\\NoAnswer',
            '.App\\Domain\\DirectConnect\\Events\\Tenants\\Ringing'
        ],
    },

    getters: {
        calendlyUrl(state) {
            return state.lead.scheduled_call
                ? `https://calendly.com/reschedulings/${state.lead.scheduled_call.event_uuid}`
                : `https://calendly.com/${state.tenant.calendly_link}`;
        },

        canClose(state) {
            return _includes(state.closableModals, state.modal);
        },

        card(state) {
            return state.card
                ? `${state.card}-card`
                : '';
        },

        events(state) {
            return state.events;
        },

        hasCalendly(state) {
            return Boolean(state.tenant.calendly_link);
        },

        hasScheduledCall(state) {
            return Boolean(state.lead.scheduled_call);
        },

        isProfile(state) {
            return ! state.tenant.wholesale;
        },

        leadId(state) {
            return state.lead.id;
        },

        leadHash(state) {
            return state.lead.hash;
        },

        leadEmail(state) {
            return state.lead.email;
        },

        leadName(state) {
            return `${state.lead.first_name} ${state.lead.last_name}`;
        },

        leadPhone(state) {
            return state.lead.phone;
        },

        modal(state) {
            return state.modal;
        },

        scheduledCall(state) {
            return state.lead.scheduled_call;
        },

        sid(state) {
            return state.sid;
        },

        started(state) {
            return state.started;
        },

        tenant(state) {
            return state.tenant;
        },

        directConnect(state) {
            return state.directConnect;
        },

        tenantPhone(state) {
            return state.tenant.contact_phone || state.tenant.phone;
        },

        directConnectFrom(state) {
            return state.directConnect.from;
        },

        directConnectFirstCallDelay(state) {
            return state.directConnect.first_call_delay;
        },

        isBusinessHours(state) {
            return state.tenant.is_during_business_hours;
        },

        canInitiateCall(state, getters) {
            return getters.isBusinessHours
                && Cookie.get('leadHash') !== state.lead.hash
                && ! getters.hasScheduledCall;
        },

        isUnactionable(state, getters) {
            return ! (getters.canInitiateCall || getters.hasCalendly);
        },

        showSpaLayout(state) {
            return state.showSpaLayout;
        },
    },

    mutations: {
        card(state, card) {
            state.card = card || false;
        },

        lead(state, lead) {
            state.lead = lead;
        },

        leadPhone(state, phone) {
            state.lead.phone = phone;
        },

        modal(state, modal) {
            state.modal = modal;
        },

        sid(state, sid) {
            state.sid = sid;
        },

        started(state, started) {
            state.started = started;
        },

        tenant(state, tenant) {
            state.tenant = tenant;
        },

        directConnect(state, directConnect) {
            state.directConnect = directConnect;
        },

        showSpaLayout(state, showSpaLayout) {
            state.showSpaLayout = showSpaLayout;
        },
    }
};
